import { useRef, useEffect } from 'react';

/* Custom hook to trigger key events in React, so we do not need to have an event listener on at all times. */
export function useKey(key, callBack) {
  const callBackRef = useRef(callBack);

  useEffect(() => {
    // Update the callback ref when the callback changes
    callBackRef.current = callBack;
  });

  useEffect(() => {
    function handleEvent(e) {
      //console.log(e);
      if (e.code === key) {
        callBackRef.current(e);
      }
    }

    // Use `keydown` instead of `keypress` to support arrow keys
    document.addEventListener('keydown', handleEvent);
    return () => {
      document.removeEventListener('keydown', handleEvent);
    };
  }, [key]);
}
